"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbiDecoderData = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _DecoderData = require("./DecoderData");
var _abi = require("@ethersproject/abi");
var _CustomCoder = require("./CustomCoder");
class AbiDecoderData {
  constructor(abi) {
    (0, _defineProperty2.default)(this, "interface", new _CustomCoder.CustomInterface([]));
    (0, _defineProperty2.default)(this, "methods", {});
    (0, _defineProperty2.default)(this, "events", {});
    (0, _defineProperty2.default)(this, "errors", {
      // Standard revert string encoding
      "08c379a0": [{
        type: "error",
        name: "Error",
        inputs: [{
          type: "string",
          name: "message"
        }]
      }]
    });
    if (abi) {
      this.addAbi(abi);
    }
  }
  addAbi(abi) {
    // Iterate new abi to generate hashes
    for (let frag of abi) {
      this.addElement((0, _DecoderData.jsonFragmentToBaseFragment)(frag));
    }
  }
  addElement(element) {
    if (element.name) {
      let list;
      if (element.type === "event") {
        let frag = _abi.EventFragment.from(element);
        element.signature = frag.format();
        element.hash = this.interface.getEventTopic(frag);
        list = this.events[element.hash.slice(2)];
        if (!list) {
          list = [];
          this.events[element.hash.slice(2)] = list;
        }
      } else if (element.type === "error") {
        let frag = _abi.ErrorFragment.from(element);
        element.signature = frag.format();
        element.hash = this.interface.getSighash(frag);
        list = this.errors[element.hash.slice(2, 10)];
        if (!list) {
          list = [];
          this.errors[element.hash.slice(2, 10)] = list;
        }
      } else {
        let frag = _abi.FunctionFragment.from(element);
        element.signature = frag.format();
        element.hash = this.interface.getSighash(frag);
        list = this.methods[element.hash.slice(2, 10)];
        if (!list) {
          list = [];
          this.methods[element.hash.slice(2, 10)] = list;
        }
      }
      if (!list.find(it => (0, _DecoderData.fragmentEquals)(it, element))) {
        list.push(element);
      }
    }
  }
  event(topic0) {
    return this.events[topic0];
  }
  func(hash) {
    return this.methods[hash];
  }
  error(hash) {
    return this.errors[hash];
  }
}
exports.AbiDecoderData = AbiDecoderData;
//# sourceMappingURL=AbiDecoderData.js.map